import React, { useState } from 'react';
import './Style/TopNavbar.css';
import BackPhone from './Backphone';
import NavigationButton from './NavigationButton';

const TopNavbar = (props) => {

  if (window.innerWidth > 1150) {
    return null;
  }

  return (
    <>


      <div className="top-navbar-mobile">

        <div className="navbar-center">
          <span className="navbar-text">
            {props.name.length > 35
              ? `${props.name.substring(0, 32)}...`
              : props.name}
          </span>
        </div>

      </div>


      <BackPhone />
      <NavigationButton />

    </>
  );
};

export default TopNavbar;